import { ButtonProps, Button as Btn, CircularProgress } from "@mui/material";
import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";

interface IButton extends ButtonProps {
  children?: string | ReactNode;
  loading?: boolean;
  isLink?: boolean;
  href?: string;
}

export const Button: FC<IButton> = ({
  children,
  loading,
  isLink,
  href,
  ...props
}) => {
  const Content = () => {
    return (
      <Btn {...props} size="medium">
        {loading ? (
          <CircularProgress
            variant="indeterminate"
            color="primary"
            size="22px"
          />
        ) : (
          children
        )}
      </Btn>
    );
  };

  return isLink && !props.disabled ? (
    <Link to={href ?? ""}>{Content()}</Link>
  ) : (
    Content()
  );
};
